import { useMemo } from "react";

import cn from "@utils/cn";
import { getIconProps } from "@utils";
import Icon from "@elements/Icon";
import DrawerItem from "@components/navbar/drawer/DrawerItem";

export default function DrawerMenu(props) {
  const {
    label,
    items,

    isExpanded,
    closeDrawer,
    onClick,
  } = props;

  const iconProps = getIconProps(label.icon, {
    fixedWidth: true,
    color: "white",
  });

  const visibleItems = useMemo(() => items?.filter((item) => {
    if ((item.isHidden) || (item.isAdminOnly && !window.appContext.isCurrentUserAdmin)) return false;
    if (item.isVisible !== undefined && item.isVisible !== "true") return false;

    return true;
  }), [items]);

  /**************************************************************************************************/

  const menuItemsListClassName = cn("overflow-hidden transition-all duration-300 ease-in-out", {
    "max-h-0 opacity-0": !isExpanded,
    "max-h-[1200px] opacity-100 py-2": isExpanded,
  });

  if (!visibleItems || visibleItems.length === 0) return null;

  return (
    <div>
      <div
        className="h-16 px-6 py-3 flex items-center gap-3 text-(--navbar-foreground-color) bg-black/20 font-medium cursor-pointer border-y border-black/10"
        onClick={onClick}
      >
        {label.icon && (
          <Icon {...iconProps} />
        )}

        <span className="text-lg">
          {label.text}
        </span>

        <span className="ml-auto flex items-center">
          <Icon
            iconName="chevron-down"
            size="sm"
            color="white"
            className={cn("transition-transform duration-300 ease-in-out", {
              "rotate-0": !isExpanded,
              "rotate-180": isExpanded,
            })}
          />
        </span>
      </div>

      <div className={menuItemsListClassName}>
        {visibleItems.map((item, index) => (
          <DrawerItem
            key={index}
            closeDrawer={closeDrawer}
            {...item}
          />
        ))}
      </div>
    </div>
  );
}
